import { useEffect } from 'react'
import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { FdeEditorDialog } from '@/frontend/features/Fde/FdeEditorSurface'
import { SelectControl, TextControl } from '@/frontend/features/Fde/FormControls'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  projectId?: string
  repositoryRevision: string | null
  copy: FdeCopy
}

export default function RepositoryPageDialog(props: Props) {
  const form = useForm({ title: '', directory: 'documentos', extension: '.md', base_commit_sha: props.repositoryRevision || '' })

  useEffect(() => {
    if (props.open) form.setData({ title: '', directory: 'documentos', extension: '.md', base_commit_sha: props.repositoryRevision || '' })
  }, [props.open, props.repositoryRevision])

  function submit() {
    if (!props.projectId) return
    form.transform((data) => ({ repository_file: data }))
    form.post(`/dashboard/discovery/repository_file?project_id=${props.projectId}`, {
      preserveScroll: true,
      onSuccess: () => props.onOpenChange(false),
    })
  }

  return <FdeEditorDialog
    open={props.open}
    onOpenChange={props.onOpenChange}
    title={props.copy.material.new_file_title}
    closeLabel={props.copy.common.close}
    size="standard"
    footer={<><Button variant="outline" onClick={() => props.onOpenChange(false)}>{props.copy.common.cancel}</Button><Button disabled={form.processing || !form.data.title.trim()} onClick={submit}>{props.copy.material.create_file}</Button></>}
  >
      <div className="grid gap-5 sm:grid-cols-2">
        <TextControl label={props.copy.material.file_title_label} value={form.data.title} onChange={(event) => form.setData('title', event.target.value)} required />
        <SelectControl label={props.copy.material.file_type} value={form.data.extension} onChange={(value) => form.setData('extension', value)} options={[
          { value: '.md', label: props.copy.material.type_markdown },
          { value: '.json', label: 'JSON' },
          { value: '.xml', label: 'XML' },
          { value: '.sql', label: 'SQL' },
          { value: '.txt', label: props.copy.material.type_text },
          { value: '.yml', label: 'YAML' },
          { value: '.mmd', label: 'Mermaid' },
        ]} />
        <SelectControl label={props.copy.material.page_directory} value={form.data.directory} onChange={(value) => form.setData('directory', value)} options={[
          { value: 'documentos', label: props.copy.material.directory_documents },
          { value: 'observacoes', label: props.copy.material.directory_notes },
          { value: 'analises', label: props.copy.material.directory_analyses },
          { value: 'processos', label: props.copy.material.directory_processes },
        ]} />
      </div>
  </FdeEditorDialog>
}
